import { BEER_INGESTION_DEFAULT_STATE } from './callableBeerConstants';

export const WORK_QUEUE_IDS = {
  INGESTION_REVIEWS: 'ingestion-reviews',
  INGESTION_ERRORS: 'ingestion-errors',
  DUPLICATE_REVIEWS: 'duplicate-reviews',
  DATA_ISSUES: 'data-issues',
  STYLE_TYPE_MAPPING: 'style-type-mapping',
};

/**
 * Review-tab badge: pending + in-progress + unapplied runs.
 */
export function sumIngestionReviewQueue(summary) {
  const pendingRuns = Number(summary?.pendingRuns) || 0;
  const inProgressRuns = Number(summary?.inProgressRuns) || 0;
  const unappliedRuns = Number(summary?.unappliedRuns) || 0;
  return pendingRuns + inProgressRuns + unappliedRuns;
}

/**
 * Failures-tab badge / Data Management card: open items in the listed page.
 */
export function readOpenFailureCount(summary) {
  return Number(summary?.open) || 0;
}

export const WORK_QUEUE_TILES = [
  {
    id: WORK_QUEUE_IDS.INGESTION_REVIEWS,
    label: 'Beer ingestion reviews',
    caption: BEER_INGESTION_DEFAULT_STATE,
    to: '/beer-ingestion?tab=review',
    countKey: 'reviews',
  },
  {
    id: WORK_QUEUE_IDS.INGESTION_ERRORS,
    label: 'Beer ingestion errors',
    caption: BEER_INGESTION_DEFAULT_STATE,
    to: '/beer-ingestion?tab=failures',
    countKey: 'errors',
  },
  {
    id: WORK_QUEUE_IDS.DUPLICATE_REVIEWS,
    label: 'Beer duplicate reviews',
    caption: null,
    to: '/beer?tab=dupes',
    countKey: 'duplicates',
  },
  {
    id: WORK_QUEUE_IDS.DATA_ISSUES,
    label: 'Data issues',
    caption: null,
    to: '/failures',
    countKey: 'dataIssues',
  },
  {
    id: WORK_QUEUE_IDS.STYLE_TYPE_MAPPING,
    label: 'Beers needing style type',
    caption: null,
    to: '/beer-styles?needsType=1',
    countKey: 'beersNeedingStyleType',
  },
];
